// /* tslint:disable: max-classes-per-file */
import { createAction, props } from '@ngrx/store';

import { StateCropSetting } from '../../cropsetting.model';

export const loadCropSettingsRequest = createAction('[Crop settings] Load crop settings request');

export const loadCropSettingsSuccess = createAction(
  '[Crop settings] Load crop settings success',
  props<{ cropSettings: StateCropSetting[] }>(),
);

export const addCropSetting = createAction('[Crop settings] Add crop settings');

export const editCropSetting = createAction(
  '[Crop settings] Edit crop settings',
  props<{ cropSetting: StateCropSetting }>(),
);

export const deleteCropSetting = createAction(
  '[Crop settings] Delete crop settings',
  props<{ cropSetting: StateCropSetting }>(),
);

export const upsertCropSetting = createAction(
  '[Crop settings] Upsert crop settings',
  props<{ cropSetting: StateCropSetting }>(),
);
